import { T, Ico, Card, Btn } from '../../../design';

export function StatsSkeleton() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {[150, 210, 150].map((h, i) => (
        <div key={i} style={{ height: h, borderRadius: 16, background: `linear-gradient(90deg,${T.tertiary} 25%, ${T.surface} 50%, ${T.tertiary} 75%)`, backgroundSize: '300% 100%', animation: 'pp-shimmer 1.3s linear infinite' }} />
      ))}
    </div>
  );
}

export function StatsError({ onRetry, message }: { onRetry: () => void; message?: string }) {
  return (
    <Card pad={28} style={{ textAlign: 'center', marginTop: 8 }}>
      <div style={{ width: 56, height: 56, borderRadius: 16, background: T.errorBg, color: T.error, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}><Ico.alert size={26} /></div>
      <div style={{ fontSize: 16, fontWeight: 800, color: T.fg }}>Kunne ikke hente statistik</div>
      <div style={{ fontSize: 13, color: T.fg3, marginTop: 6, lineHeight: 1.5 }}>{message || 'Der opstod en fejl. Tjek forbindelsen og prøv igen.'}</div>
      <Btn variant="secondary" size="md" onClick={onRetry} style={{ marginTop: 16 }}>Prøv igen</Btn>
    </Card>
  );
}
